import React from 'react';

function Contact() {

    return (
        <div className="font-script">
            <section id="newsletter-cta" className="py-20 bg-white">
                <div className="max-w-7xl mx-auto px-6">
                    <div className="text-center mb-16">
                        <h2 className="text-5xl font-serif font-bold text-gray-800 mb-6">Get in Touch</h2>
                        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                            Έχετε ερωτήσεις σχετικά με τα καλάθια μας ή θέλετε να κάνετε μια παραγγελία; Θα χαρούμε πολύ
                            να σας ακούσουμε!
                        </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                        <div id="contact-card-1" className="bg-cream rounded-xl p-8 text-center">
                            <div
                                className="w-16 h-16 bg-brand-green rounded-full flex items-center justify-center mx-auto mb-6">
                                <i className="fas fa-envelope text-2xl text-white"></i>
                            </div>
                            <h3 className="text-xl font-serif font-semibold mb-3 text-gray-800">Επικοινωνήστε μαζί
                                μας</h3>
                            <p className="text-gray-600 mb-2">Απαντάμε μέσα σε 24 ώρες.</p>
                            <a href="mailto:info@rotheras.gr"
                               className="text-brand-green font-semibold text-lg hover:text-dark-green transition-colors">info@rotheras.gr</a>
                        </div>

                        <div id="contact-card-2" className="bg-cream rounded-xl p-8 text-center">
                            <div
                                className="w-16 h-16 bg-brand-green rounded-full flex items-center justify-center mx-auto mb-6">
                                <i className="fab fa-facebook-f text-2xl text-white"></i>
                            </div>
                            <h3 className="text-xl font-serif font-semibold mb-3 text-gray-800">Facebook</h3>
                            <p className="text-gray-600 mb-4">Ακολουθήστε μας για να μαθαίνετε νέα μας.</p>
                            <a href="https://www.facebook.com/profile.php?id=61579219806404"
                               className="w-12 h-12 bg-brand-green rounded-full flex items-center justify-center hover:bg-dark-green transition-colors mx-auto">
                                <i className="fab fa-facebook-f text-white text-lg"></i>
                            </a>
                        </div>

                        <div id="contact-card-3" className="bg-cream rounded-xl p-8 text-center">
                            <div
                                className="w-16 h-16 bg-brand-green rounded-full flex items-center justify-center mx-auto mb-6">
                                <i className="fab fa-instagram text-2xl text-white"></i>
                            </div>
                            <h3 className="text-xl font-serif font-semibold mb-3 text-gray-800">Instagram</h3>
                            <p className="text-gray-600 mb-4">Δείτε τις ποιο πρόσφατες δημιουργίες μας.</p>
                            <a href="https://www.instagram.com/rotheras_baskets/"
                               className="w-12 h-12 bg-brand-green rounded-full flex items-center justify-center hover:bg-dark-green transition-colors mx-auto">
                                <i className="fab fa-instagram text-white text-lg"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Contact;